/*
 * lb-journal.js : sommaire de l'article « Le Journal ».
 * Construit la liste depuis les H2 du texte, la garde alignée sur le défilement, et la replie sur mobile.
 * Chargé uniquement par sections/article-template.liquid.
 */
(function () {
  'use strict';
  var toc = document.querySelector('[data-lb-toc]');
  var body = document.querySelector('.lb-article .article__body');
  if (!toc || !body) return;

  var root = toc.closest('.lb-article');
  var details = toc.querySelector('details');
  var list = toc.querySelector('ol');
  var heads = Array.prototype.slice.call(body.querySelectorAll('h2'));

  // Moins de 2 rubriques : pas de sommaire, le texte reprend toute la place
  if (heads.length < 2) {
    toc.parentNode.removeChild(toc);
    if (root) root.classList.remove('lb-article--toc');
    return;
  }

  function slug(s) {
    return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 48);
  }

  var links = heads.map(function (h, i) {
    if (!h.id) h.id = (i + 1) + '-' + (slug(h.textContent) || 'section');
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    list.appendChild(li);
    return a;
  });
  toc.hidden = false;

  // Bureau : sommaire toujours ouvert ; mobile : replié
  var mq = window.matchMedia('(min-width: 861px)');
  function sync() {
    details.open = mq.matches;
    toc.classList.toggle('lb-toc--static', mq.matches);
  }
  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
  details.querySelector('summary').addEventListener('click', function (e) {
    if (mq.matches) e.preventDefault();
  });
  list.addEventListener('click', function (e) {
    if (e.target.closest('a') && !mq.matches) details.open = false;
  });

  // Rubrique active au défilement
  var ticking = false;
  function setActive() {
    ticking = false;
    var cur = 0;
    heads.forEach(function (h, i) { if (h.getBoundingClientRect().top <= 140) cur = i; });
    links.forEach(function (a, i) {
      a.classList.toggle('is-active', i === cur);
      if (i === cur) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(setActive); }
  }, { passive: true });
  setActive();
})();
